module.exports = __webpack_public_path__ + "static/media/sendbg.eb71fbf2.png";